<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">#</th>
        <th scope="col" class="border-0">Code</th>
        <th scope="col" class="border-0">Nome</th>
        <th scope="col" class="border-0">Marca</th>
        <th scope="col" class="border-0 text-center">Preço</th>
        <th scope="col" class="border-0 text-center">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in products" :key="index">
        <td>{{ row.id }}</td>
        <td class="td-1">{{ row.main_variation.code }}</td>
        <td class="td-4 link">
          <d-link :to="{ name: 'admin-product-edit', params: { productId: row.id, page: 1 }}">{{ row.name }}</d-link>
        </td>
        <td class="td-3">{{ row.brand }}</td>
        <td class="td-2 text-right">{{ addCurrencyMask(row.main_variation.price) }}</td>
        <td class="td-2 text-center">
          <product-buttons :product="row"></product-buttons>
        </td>
      </tr>
      <tr v-if="products.length === 0">
        <td colspan="7" class="no-content">Ainda não tem nenhum produto cadastrado.</td>
      </tr>
    </tbody>
    <confirmation-modal
      :cancel="close"
      :confirm="deleteRow"
      title="Confirme exclusão de produto"
      message="Tem certeza que deseja excluir esse produto?"/>
  </table>
</template>

<script>
import Events from '_utils/events';
import CurrencyMask from '_common/mixins/CurrencyMask';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import ProductDelete from './ProductDelete';
import ProductButtons from './ProductButtons.vue';
import { _DELETE_PRODUCT_ } from './ProductModel';

export default {
  name: 'product-table',
  mixins: [ProductDelete, CurrencyMask],
  components: {
    ProductButtons,
    ConfirmationModal,
  },
  props: {
    products: {
      type: Array,
    },
  },
  data() {
    return {
      selectedObject: null,
    };
  },
  mounted() {
    Events.$on(_DELETE_PRODUCT_, product => {
      this.selectedObject = product;
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.td {
  &-1 {
    min-width: 100px;
  }
  &-2 {
    min-width: 120px;
  }
  &-3 {
    min-width: 170px;
  }
  &-4 {
    min-width: 300px;
  }
}
</style>
